// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"362": "LazyIdentificationForm","616": "LazyGoogleOneTap",}[chunkId] + "." + {"362": "368db4f0a38ab5f3","616": "ff2bb0f8691e94f8",}[chunkId] + ".js"
}